import { getFacebookEvent } from './rooms'

// Attaches facebook messenger metadata from the room state
export const attachFacebookMetadata = (room, content) => {
  const fbData = getFacebookEvent(room)
  const newContent = { ...content }

  if (fbData) {
    newContent.fb = {
      ...fbData,
    }
  }
  return newContent
}
